import { render } from "./assessment-fluctuation.vue?vue&type=template&id=ccfe5fb8&scoped=true&ts=true"
import script from "./assessment-fluctuation.vue?vue&type=script&lang=ts"
export * from "./assessment-fluctuation.vue?vue&type=script&lang=ts"

import "./assessment-fluctuation.vue?vue&type=style&index=0&id=ccfe5fb8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccfe5fb8"]])

export default __exports__